import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";

export const blogListApi = async () => {
    try {
        const response = await axios.get(`${baseUrl}blog-list`, {});
        return response?.data?.data;
    } catch (error) {
        return null;
    }
};

export const blogDetailApi = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}blog-details/${id}`, {});
        return response?.data?.data?.data;
    } catch (error) {
        return null;
    }
};